<template>
  <v-dialog
    v-model="show"
    :persistent="isPersistent"
    max-width="440px">
    <v-card class="pa-2">
      <v-card-title class="fs-16 fw-bold title justify-center my-3">{{title}}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="fs-16 fw-semi-bold text-center mt-3" v-html="content">
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn flat class="fs-14 border-1" @click="cancelAction">{{cancelButtonText}}</v-btn>
        <v-btn flat class="fs-14" :class="confirmButtonClass" :loading="loading" :disabled="loading" @click="confirmAction">
          {{confirmButtonText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'simple_dialog',
  props: {
    isPersistent: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    cancelButtonText: {
      type: String,
      default: 'キャンセル'
    },
    confirmButtonText: {
      type: String,
      default: '確認'
    },
    loading: {
      type: Boolean,
      default: false
    },
    confirmButtonClass: {
      type: String,
      default: 'registration'
    },
    cancelAction: {
      type: Function
    },
    confirmAction: {
      type: Function
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/simple_dialog.vue